























































import Vue from 'vue';
import MStoreFormLookup from '@/components/shared/MStoreFormLookup.vue';
import MStoreFormSelectTable from '@/components/shared/MStoreFormSelectTable.vue';
import WorkflowUnsupportedInput from '@/components/workflow/WorkflowUnsupportedInput.vue';
import { WorkflowFormValidation, ObjectHelper, ActionButtonHandler } from '@/mixins';
import { ListService } from '@/services/ListService';
import { WorkflowDataSourceFieldListType, ActionButtonType } from '@/types/enums';
import { Dictionary } from '@/types';

export default Vue.extend({
  name: 'WorkflowFormSelect',
  mixins: [WorkflowFormValidation, ActionButtonHandler, ObjectHelper],
  props: {
    inputProperties: {
      type: Object,
      required: true
    },
    allFields: {
      type: Object as () => Dictionary<any>,
      required: true
    },
    data: {
      required: true
    },
    ignoreIsRequired: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    useAltAxis: {
      type: Boolean,
      default: false
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataFieldList: {},
      isLoading: false
    };
  },
  methods: {
    async getWorkflowDataFieldListAsync(this: any) {
      this.isLoading = true;
      try {
        await ListService.getWorkflowDataFieldListAsync(this.inputProperties.additionalProperties.jobId, this.inputProperties.dataSourceKey, this.inputProperties.fieldName).then((result: any) => {
          this.dataFieldList = result;
          this.isLoading = false;
        });
      } catch (error) {
        this.$log(`Error getting data-field list ${error}`);
        this.isLoading = false;
      }
    },
    onUpdateData(value: any) {
      this.$emit('update:data', value);
    },
    onRowSelected(this: any, row: any) {
      this.updateDataFieldsAfterListSelection(row);
      this.evaluateFieldUpdateRules(row);
    },
    updateDataFieldsAfterListSelection(this: any, row: any) {
      const dataFieldsToUpdateAfterListSelection = this.inputProperties.additionalProperties.dataFieldsToUpdateAfterListSelection;
      if (this.isNullOrEmpty(dataFieldsToUpdateAfterListSelection) || dataFieldsToUpdateAfterListSelection.length === 0 || this.isNullOrEmpty(row)) {
        return;
      }
      this.$emit('field-with-list-selection-rule-updated', { dataFieldsToUpdateAfterListSelection, row });
    },
    evaluateFieldUpdateRules(this: any, row: any) {
      if (this.isNullOrEmpty(row)) {
        return;
      }
      if (this.inputProperties.additionalProperties.isRuleField) {
        this.$emit('rule-field-updated');
      }
    },
    initialise(this: any) {
      if (this.isSqlListType(this.inputProperties.additionalProperties.listType)) {
        this.getWorkflowDataFieldListAsync();
      }
    },
    isMafListType(listType: WorkflowDataSourceFieldListType) {
      return listType === WorkflowDataSourceFieldListType.Maf;
    },
    isSqlListType(listType: WorkflowDataSourceFieldListType) {
      return listType === WorkflowDataSourceFieldListType.Sql;
    },
    onActionButtonClicked(this: any) {
      this.performButtonClick(this.actionButtonType, this.actionButtonState);
    }
  },
  computed: {
    actionButtonData(): object {
      return {};
    },
    actionButtonType(this: any): ActionButtonType {
      return this.inputProperties.additionalProperties.actionButtonType ? (this.inputProperties.additionalProperties.actionButtonType as ActionButtonType) : ActionButtonType.None;
    },
    actionButtonState(this: any): any {
      if (this.actionButtonType === ActionButtonType.None) {
        return {};
      }
      const state = this.getActionButtonState(this.actionButtonType, this.inputProperties.additionalProperties.actionButtonProperties);
      return state;
    }
  },
  mounted(this: any) {
    this.initialise();
  },
  components: {
    MStoreFormLookup,
    MStoreFormSelectTable,
    WorkflowUnsupportedInput
  }
});
